export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
  color: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    id: 'wanghong-tafang',
    name: '网红塌房',
    slug: 'wanghong-tafang',
    description: '聚焦全网网红主播塌房事件，曝光最真实的内幕与反转剧情',
    icon: 'ri-user-unfollow-line',
    color: 'primary',
    articleCount: 156,
  },
  {
    id: 'zhubo-baoliao',
    name: '主播爆料',
    slug: 'zhubo-baoliao',
    description: '各大直播平台主播独家爆料，揭秘直播圈不为人知的秘密',
    icon: 'ri-live-line',
    color: 'accent',
    articleCount: 234,
  },
  {
    id: 'meiri-chigua',
    name: '每日吃瓜',
    slug: 'meiri-chigua',
    description: '每日精选全网最热吃瓜大瓜，带你第一时间掌握全网动态',
    icon: 'ri-water-flash-line',
    color: 'primary',
    articleCount: 892,
  },
  {
    id: 'dujia-mengliao',
    name: '独家猛料',
    slug: 'dujia-mengliao',
    description: '51黑料网独家首发爆料，第一手资料全网首发',
    icon: 'ri-vip-crown-line',
    color: 'accent',
    articleCount: 67,
  },
  {
    id: 'fanxiang-neimu',
    name: '反差内幕',
    slug: 'fanxiang-neimu',
    description: '揭露网红主播台前幕后的巨大反差，还原最真实的娱乐圈',
    icon: 'ri-contrast-line',
    color: 'secondary',
    articleCount: 145,
  },
  {
    id: 'yule-baoliao',
    name: '娱乐爆料',
    slug: 'yule-baoliao',
    description: '明星艺人最新八卦爆料，娱乐新闻一网打尽',
    icon: 'ri-star-line',
    color: 'primary',
    articleCount: 378,
  },
  {
    id: 'shipin-jingxuan',
    name: '视频精选',
    slug: 'shipin-jingxuan',
    description: '精选全网最火爆爆料视频，在线观看高清完整版',
    icon: 'ri-video-line',
    color: 'accent',
    articleCount: 203,
  },
  {
    id: 'remen-huati',
    name: '热门话题',
    slug: 'remen-huati',
    description: '全网热门话题深度追踪，持续更新最热讨论焦点',
    icon: 'ri-fire-line',
    color: 'primary',
    articleCount: 567,
  },
];